import { gsap } from 'gsap';
import * as Sentry from "@sentry/browser";
import { Accordion } from './components/accordion.js'
import { AccordionItem } from './components/accordion-item.js'
import { InvertedAccordionItem } from './components/inverted-accordion-item.js'
import fontdue from "https://js.fontdue.com/fontdue.esm.js";
import FitText from './components/fittext.js';
import TypeAnimation from './components/type-animation.js';
import StylableSelect from './components/stylable-select.js';
import { Modal } from './components/modal.js';
import { initInlineButtonActions } from './components/inline-button-actions.js';
import DarkLightToggle from './components/dark-light-toggle.js';
import { initVideoSync } from './components/video-sync.js';

Sentry.init({
  dsn: "https://0fa18f9e4af378a07c136041d5f0783e@o4511067766390784.ingest.de.sentry.io/4511067886387280",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

// Make GSAP available globally for components that use window.gsap as a guard
window.gsap = gsap;

customElements.define('stylable-select', StylableSelect);
customElements.define('gt-accordion', Accordion);
customElements.define('gt-accordion-item', AccordionItem);
customElements.define('gt-inverted-accordion-item', InvertedAccordionItem);
customElements.define('dark-light-toggle', DarkLightToggle);

// Lazy load the typetester (opentype.js + woff2-encoder are very heavy) only
// when the page actually contains a <lit-typetester> element.
if (document.querySelector('lit-typetester')) {
  import('./components/typetester.js').then(({ default: Typetester }) => {
    customElements.define('lit-typetester', Typetester);
  });
}

// Lazy load Swiper only on pages that use <swiper-container>.
if (document.querySelector('swiper-container')) {
  import('swiper/element/bundle').then(({ register }) => {
    register();
  });
}

fontdue.initialize({
  // url: "/fd",
  url: "https://store.gallerytype.com/graphql",
  config: {
    typeTester: {
      size: {
        min: 6,
        max: 480,
        label: 'Size',
      },
      selectable: true,
      textInput: false,
      groupEdit: false,
      initialMode: 'local',
      shy: true,
      buyButton: true,
      selectButtonLabel: 'Buy',
      selectButtonStyle: 'outlined',
    },
  },
});

// Initialize inline button actions
initInlineButtonActions();

// Initialize video synchronization for theme switching
initVideoSync();

// Mobile navigation toggle functionality
document.addEventListener('DOMContentLoaded', () => {
  const headerHeight = document.querySelector('header').offsetHeight;
  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);

  const toggleButton = document.querySelector('.toggle');
  const nav = document.querySelector('header nav');

  if (toggleButton && nav) {
    // Toggle button click handler
    toggleButton.addEventListener('click', () => {
      nav.classList.toggle('open');
      toggleButton.classList.toggle('active');

      // Update aria-expanded for accessibility
      const isExpanded = nav.classList.contains('open');
      toggleButton.setAttribute('aria-expanded', isExpanded);
      nav.setAttribute('aria-hidden', !isExpanded);
    });

    // Initialize aria attributes
    toggleButton.setAttribute('aria-expanded', 'false');
    toggleButton.setAttribute('aria-label', 'Toggle navigation menu');

    // Set initial aria-hidden based on viewport width
    if (window.innerWidth < 768) {
      nav.setAttribute('aria-hidden', 'true');
    } else {
      nav.setAttribute('aria-hidden', 'false');
    }

    // Close menu when resizing to desktop
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 768) {
        nav.classList.remove('open');
        toggleButton.classList.remove('active');
        nav.setAttribute('aria-hidden', 'false');
      } else {
        const isOpen = nav.classList.contains('open');
        nav.setAttribute('aria-hidden', !isOpen);
      }
    });
  }
});
